import PlainButtonLink, { type Props as PlainButtonLinkProps } from './plain-button-as-link'


export default PlainButtonLink
export type { PlainButtonLinkProps }
